//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import { initialiseForm } from "@donutteam/document-builder-components/src/client.js";

import { createPasswordResetToken } from "../../../../api/routes/v7/passwordResetToken/create.schemas.js";

//
// Components
//

export function initialiseForgotPasswordForm(forgotPasswordForm: HTMLFormElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(forgotPasswordForm, "apiUrl");

	const emailInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(forgotPasswordForm, `input[name="email"]`);

	initialiseForm(forgotPasswordForm,
		async () =>
		{
			// Note: This input doesn't exist until the form is submitted, so we get it here instead
			const recaptchaTokenInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(forgotPasswordForm, "input[name=recaptcha_token]");

			const response = await createPasswordResetToken(apiUrl, recaptchaTokenInput.value, emailInput.value);

			if (!response.success)
			{
				return {
					restoreInputs: true,
					notices: response.errors.map((error) => ({ type: "warning", message: error.message, dismissible: true })),
				};
			}

			forgotPasswordForm.reset();

			return {
				restoreInputs: true,
				notices: 
				[
					{
						type: "success",
						message: "If your email address is registered with Donut Team, we've sent you an email with instructions on how to reset your password.",
						dismissible: true,
					},
				],
			};
		});
		
	forgotPasswordForm.classList.add("initialised");
}

export function initialiseForgotPasswordForms()
{
	const forgotPasswordForms = document.querySelectorAll<HTMLFormElement>(".component-forgot-password-form:not(.initialised)");

	console.log("[ForgotPasswordForm] Initialising " + forgotPasswordForms.length + " instances...");

	for (const forgotPasswordForm of forgotPasswordForms)
	{
		try
		{
			initialiseForgotPasswordForm(forgotPasswordForm);
		}
		catch (error)
		{
			console.error("[ForgotPasswordForm] Error initialising:", forgotPasswordForm, error);
		}
	}
}